import React, { FC, useCallback } from 'react';
import { Spinner } from 'src/common';
import styles from './index.module.scss';
import WorkspaceBadge from 'src/common/WorkspaceBadge';
import { IWorkspace } from 'src/models/workspace/types';
import { useOpenSidebar } from 'src/shared/InfoSidebar/hooks';
import { SidebarMode } from 'src/shared/InfoSidebar/types';
import WorkspaceQuickActions from './WorkspaceQuickActions';
import { useWorkspaceArchivingAvailable, useWorkspace } from 'src/models/workspace/hooks';
import { useTenderUpdateVisibility } from 'src/models/users/NotificationSettings/hooks';
import { WorkspaceNotifications } from 'src/shared';
import MemberList from 'src/common/MembersList';

interface IProps {
  workspace: IWorkspace;
  pending: boolean;
}

export const WorkspaceTitle: FC<IProps> = (props: IProps) => {
  const { workspace, pending } = props;
  const openWsPreview = useOpenSidebar();

  const showDrawer = useCallback(() => {
    openWsPreview({ id: workspace.id, mode: SidebarMode.WORKSPACE_INFO });
  }, [openWsPreview, workspace.id]);

  const archivingAvailable = useWorkspaceArchivingAvailable();
  const { data: ws, loading: wsLoading } = useWorkspace();

  const isLoading = wsLoading;

  const isTenderUpdateFeature = useTenderUpdateVisibility();

  return (
    <div className={styles.header}>
      <WorkspaceBadge title={workspace.name} color={workspace.color} mode={'full'} className={styles.title} tooltip />
      {(pending || isLoading) && <Spinner />}
      <div className={styles.actions}>
        {!!isTenderUpdateFeature && <WorkspaceNotifications />}
        <MemberList
          onClick={showDrawer}
          owners={ws?.owners}
          subscribersList={ws?.subscribers}
          accessControlPolicy={ws?.accessControl.subscribePolicy}
          loading={wsLoading}
        />
        {archivingAvailable && <WorkspaceQuickActions workspaceId={workspace.id} isActive={workspace.isActive} />}
      </div>
    </div>
  );
};

export default WorkspaceTitle;
